import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class AccordionController {

    private accordionGroups = new BehaviorSubject<Record<string, string>>({});

    constructor() {}

    open(groupId: string, id: string) {
        const current = this.accordionGroups.value;
        current[groupId] = id;
        this.accordionGroups.next(current);
    }

    asObservable(): Observable<Record<string, string>> {
        return this.accordionGroups.asObservable();
    }
}
